import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import Button from '../ui/Button';

const ROLE_LABELS = {
  fpo_admin: 'FPO Admin',
  buyer: 'Buyer',
};

export default function AppNavbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-30 w-full border-b border-gray-200 bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <Link to="/app" className="flex items-baseline gap-2">
          <span className="text-lg font-bold tracking-tight text-green-800">Atharva</span>
          <span className="text-xs uppercase tracking-widest text-gray-400">
            {user ? ROLE_LABELS[user.role] || user.role : ''}
          </span>
        </Link>
        <div className="flex items-center gap-3 text-sm">
          {user && <span className="hidden text-gray-600 sm:inline">{user.full_name || user.username}</span>}
          <Button variant="ghost" size="sm" onClick={handleLogout}>
            Sign out
          </Button>
        </div>
      </div>
    </header>
  );
}
